import { UnfoldMore as UnfoldMoreIcon } from '@mui/icons-material';
import { Box, Menu } from '@mui/material';
import { StyledLocationSortButton } from 'src/components/table/CustomTable.styled';
import { RowsPerPageOptions } from 'src/components/table/CustomTableWithPagination/TableControlsHeader/TableControlsHeader.interface';
import { useMenu } from 'src/hooks';
import { DataTestID, lang } from 'src/utils';

import type { SubHeaderWithPageProps } from './SubHeaderWithPage.interface';
import {
  FlexRowCenter,
  HeaderText,
  NoWrapTypography,
  StyledLabel,
  StyledPageMenuItem,
  StyledTypography,
  SubHeaderContainer,
} from './SubHeaderWithPage.styled';

export const SubHeaderWithPage = (props: SubHeaderWithPageProps) => {
  const menu = useMenu();

  const items = [
    {
      label: String(RowsPerPageOptions.TWENTY),
      isSelected: props.itemsPerPage === RowsPerPageOptions.TWENTY,
      onClick: () => props.onItemsPerPageChange(RowsPerPageOptions.TWENTY),
    },
    {
      label: String(RowsPerPageOptions.FIFTY),
      isSelected: props.itemsPerPage === RowsPerPageOptions.FIFTY,
      onClick: () => props.onItemsPerPageChange(RowsPerPageOptions.FIFTY),
    },
    {
      label: String(RowsPerPageOptions.ONE_HUNDRED),
      isSelected: props.itemsPerPage === RowsPerPageOptions.ONE_HUNDRED,
      onClick: () => props.onItemsPerPageChange(RowsPerPageOptions.ONE_HUNDRED),
    },
  ];

  const pageText =
    props.totalCount > 0
      ? `Results: ${props.startItem}-${props.endItem}/${props.totalCount}`
      : 'Results: 0/0';

  return (
    <SubHeaderContainer alignItems="align-start" flexDirection="column">
      <HeaderText>{props.title}</HeaderText>

      <Box display="flex" alignItems="center" mt={1}>
        <Box sx={{ flex: 1 }}>
          <StyledTypography>{pageText}</StyledTypography>
        </Box>
        <Box display="flex" alignItems="center" gap={3}>
          {props.onSelectAllClick && (
            <StyledLabel
              disabled={props.totalPages === 0 || props.disableSelectAll}
              data-testid={DataTestID.SubHeaderWithPageStyledLabel}
              onClick={
                props.totalPages === 0 || props.disableSelectAll
                  ? undefined
                  : props.onSelectAllClick
              }>
              {props.isSelectedAll ? lang.unSelectAll : lang.selectAll}
            </StyledLabel>
          )}

          <FlexRowCenter>
            <NoWrapTypography>{lang.itemsPerPage}</NoWrapTypography>
            <StyledLocationSortButton
              variant="text"
              endIcon={<UnfoldMoreIcon />}
              disableRipple
              disabled={props.totalPages === 0}
              onClick={(
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
              ) => menu.onOpenMenu(event.currentTarget)}>
              {items.find((item) => item.isSelected)?.label}
            </StyledLocationSortButton>
            <Menu
              anchorEl={menu.anchorEl}
              onClose={menu.onCloseMenu}
              open={Boolean(menu.anchorEl)}>
              {items.map((item) => (
                <StyledPageMenuItem
                  role="menuitem"
                  key={item.label}
                  selected={item.isSelected}
                  onClick={() => {
                    item.onClick();
                    menu.onCloseMenu();
                  }}>
                  {item.label}
                </StyledPageMenuItem>
              ))}
            </Menu>
          </FlexRowCenter>
        </Box>
      </Box>
    </SubHeaderContainer>
  );
};
